module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-badge",
    class: {
      'uk-badge-success': _vm.color == 'success',
        'uk-badge-warning': _vm.color == 'warning',
        'uk-badge-danger': _vm.color == 'danger'
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-557b7e3b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UkBadge.vue
// module id = 293
// module chunks = 2